import { useCallback } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { CallbackData } from '#src/app/pages/petitionDetails/shared/types';

export function useGetUserData(): (data: CallbackData) => Record<string, unknown> {
	const {
		data: { petition: details },
	} = usePetitionDetailsPageData();

	return useCallback(
		({ formData, user }: CallbackData) => ({
			user_id: user?.id,
			petition_id: details.id,
			email: formData.email,
			connected_to_facebook: user?.connectedToFacebook,
			password_set: user?.passwordSet,
		}),
		[details],
	);
}
